import { createApp } from 'vue';
import './styles/theme.css';
import './styles/styles.css';
import './styles/dartsHubTheme.css';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/solid.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(Vue3Toastify, {
  position: 'bottom-right',
  timeout: 3000,
  closeOnClick: true,
});

app.mount('#app');
